import {
    AUTH_USER_SET,
} from "actions/auth/constants";

const initialState = {
    isAuthenticated: false,
    user: {},
    roles: [], // [{authority: "ROLE_MODERATOR"}]
};

export default function(state = initialState, action) {
    switch (action.type) {
        case AUTH_USER_SET:
            return {
                ...state,
                isAuthenticated: !!action.payload,
                user: action.payload.user,
                roles: action.payload.roles,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js